import React from "react";
import PropTypes from "prop-types";
import getFilesUrl from "../../../helpers/getFilesUrl";
import Translations from "./translations";
import languages from "../../../data/languages";

const languageTemplate = {
  description: "",
  language: "",
  name: "",
  priceName: ""
};

const extendedDetailsTemplate = {
  order: 1000,
  translations: Object.keys(languages).map(langKey => ({
    ...languageTemplate,
    language: langKey
  }))
};

class EditModal extends React.Component {
  constructor(props) {
    super(props);

    const { tariff } = this.props;
    this.state = {
      id: tariff ? tariff.id : false,
      code: tariff ? tariff.code : "",
      active: tariff ? tariff.active : false,
      activable: tariff ? tariff.activable : false,
      order: tariff ? tariff.order : 0,
      pricing: tariff ? tariff.pricing : 0,
      type: tariff ? tariff.type : 0,
      translations: tariff ? tariff.translations : Object.keys(languages).map(langKey => ({
        ...languageTemplate,
        language: langKey
      })),
      extendedDetails: tariff ? tariff.extendedDetails : [],
      logo: tariff ? tariff.logo : {},

      previewImage: getFilesUrl(tariff.logo),
      imageFile: null,
    };
  }

  handleChangeImage = ev => {
    const file = ev.target.files[0];
    this.setState({
      previewImage: URL.createObjectURL(file),
      imageFile: file
    });
  };

  handleChangeLanguage = (lang, name, value) => {
    const translations = [...this.state.translations];

    const languageItemIndex = translations.findIndex(i => i.language === lang);
    const languageItem = (languageItemIndex === -1) ? { ...languageTemplate } : { ...translations[languageItemIndex] };

    languageItem.language = lang;
    languageItem[name] = value;

    this.setState({
      translations: [
        ...this.state.translations.filter(i => i.language !== lang),
        languageItem
      ]
    });
  };

  addNewExtendedDetail = () => {
    this.setState({
      extendedDetails: [...this.state.extendedDetails, extendedDetailsTemplate]
    });
  };

  handleChangeExtendedDetails = (index, value) => {
    const extendedDetails = [...this.state.extendedDetails];
    extendedDetails[index] = {
      ...extendedDetails[index],
      order: +value
    };
    this.setState({
      extendedDetails
    });
  };

  handleChangeExtendedDetailsLanguage = (index, lang, name, value) => {
    const extendedDetails = [...this.state.extendedDetails];
    const currentDetails = { ...extendedDetails[index] };
    const translations = [...currentDetails.translations];

    const languageItemIndex = translations.findIndex(i => i.language === lang);
    const languageItem = (languageItemIndex === -1) ? { ...languageTemplate } : { ...translations[languageItemIndex] };

    languageItem.language = lang;
    languageItem[name] = value;

    translations[languageItemIndex] = languageItem;

    extendedDetails[index] = {
      ...currentDetails,
      translations
    };

    this.setState({
      extendedDetails
    });
  };

  handleChangeForm = (ev) => {
    const {
      name,
      value
    } = ev.target;
    this.setState({
      [name]: value
    });
  };

  handleSubmit = () => {
    const data = Object.assign({}, this.state);
    if (!data.id) {
      delete data.id;
    }
    this.props.onSubmit(data);
  };

  render() {
    const { types } = this.props;
    const {
      // name,
      pricing,
      code,
      active,
      activable,
      order,
      type,
      translations,
      extendedDetails,
      previewImage,
    } = this.state;

    return (
      <div>
        <div className="row">
          {/* <div className="col-6">
            <div className="form-group">
              <label>Name</label>
              <input
                className="form-control form-control-sm"
                type="text"
                value={name}
                name="name"
                onChange={this.handleChangeForm}
              />
            </div>
          </div> */}
          <div className="col-6">
            <div className="form-group">
              <label>Pricing</label>
              <input
                className="form-control form-control-sm"
                type="number"
                min={0}
                value={pricing}
                name="pricing"
                onChange={this.handleChangeForm}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label>Code</label>
              <input
                className="form-control form-control-sm"
                type="text"
                value={code}
                name="code"
                onChange={this.handleChangeForm}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="form-group">
              <label>Active</label>
              <select
                className="form-control form-control-sm"
                onChange={ev => this.setState({
                  active: Boolean(+ev.target.value)
                })}
                value={active ? "1" : "0"}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div className="col-3">
            <div className="form-group">
              <label>Activable</label>
              <select
                className="form-control form-control-sm"
                onChange={ev => this.setState({
                  activable: Boolean(+ev.target.value)
                })}
                value={activable ? "1" : "0"}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div className="col-3">
            <div className="form-group">
              <label>Order</label>
              <input
                className="form-control form-control-sm"
                type="number"
                value={order}
                onChange={ev => this.setState({
                  order: +ev.target.value
                })}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="form-group">
              <label>Type</label>
              <select
                className="form-control form-control-sm"
                onChange={this.handleChangeForm}
                name="type"
                value={type}
              >
                {types.map(perType => (
                  <option value={perType} key={perType}>{perType}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-12">
            <Translations
              onChange={this.handleChangeLanguage}
              translations={translations}
            />
          </div>

          <div className="col-12">
            <label>Image</label>
            <input
              className="form-control"
              accept="image/*"
              type="file"
              name="image"
              placeholder="Upload Image"
              onChange={this.handleChangeImage}
            />
            {previewImage && (
              <div className="mb-3 text-center">
                <img
                  src={previewImage}
                  alt="Preview"
                  className="img-thumbnail"
                  style={{
                    maxWidth: "100%",
                    width: "auto",
                    marginTop: 20
                  }}
                />
              </div>
            )}
          </div>

          {type === "RIDE_BIKE_EXTENDED" ? (
            <React.Fragment>
              <div className="col-12"><b>Extended Details</b></div>
              <div className="col-12">
                {Array.isArray(extendedDetails) ? (
                  <div>
                    {extendedDetails.map((extendedDetail, index) => (
                      <div key={index}>
                        <div className="form-group">
                          <label>Order</label>
                          <input
                            className="form-control form-control-sm"
                            type="number"
                            value={extendedDetail.order}
                            onChange={ev => this.handleChangeExtendedDetails(index, ev.target.value)}
                          />
                        </div>
                        <div>
                          <Translations
                            translations={extendedDetail.translations}
                            onChange={(lang, name, value) => this.handleChangeExtendedDetailsLanguage(index, lang, name, value)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
              <div className='col-12'>
                <button className="btn btn-block btn-warning" onClick={this.addNewExtendedDetail}>
                  Add more Extended Details
                </button>
              </div>
            </React.Fragment>
          ) : null}
        </div>
        <div className="text-right mt-2">
          <button
            className="btn btn-danger mr-2"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={this.handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

EditModal.propTypes = {
  tariff: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default EditModal;



// WEBPACK FOOTER //
// ./src/views/pages/tariff/edit-modal.js